import React, {useState} from "react";
import { DatePicker as AKDatePicker, DatePickerProps} from '@atlaskit/datetime-picker';
import moment from 'moment';

export type { DatePickerProps } from '@atlaskit/datetime-picker';

interface Props extends DatePickerProps {
};


const defaultProps: Partial<DatePickerProps> =  {
  placeholder: moment().format('L'),
  locale: 'nl-NL',
  dateFormat: "DD-MM-YYYY" // will be deprecated :(

};

export const DatePicker = ({...props}: Props) => {
    return (
        <AKDatePicker {...props}/>
        );
};
DatePicker.defaultProps = defaultProps;

export default DatePicker;
